import { ActiveFilters, GridColumn } from '@grid/abstractions';
import { QueryFilterBuilder } from '../helpers/types/query-filter-builder.type';
import { FilterTypesDefinition } from './filter-types-definition';

export class ColumnFilterDefinition extends FilterTypesDefinition {
  constructor(column: GridColumn) {
    super(column);
  }

  get columnKey(): string {
    return this.column.key;
  }

  get label(): string {
    return this.column.label;
  }

  get queryBuilder(): QueryFilterBuilder {
    return this.column.filterableColumn!.oDataQueryBuilder;
  }

  getOptions<T>(): T {
    return this.column.filterableColumn?.options as T;
  }

  checkDisableState(activeFilters: ActiveFilters): boolean {
    const disableIfResolver = this.column.filterableColumn?.disableIf;
    if (disableIfResolver !== undefined) {
      const disableIfResolver = this.column.filterableColumn?.disableIf;
      if (typeof disableIfResolver === 'function') {
        return disableIfResolver(activeFilters);
      }
      return <boolean>disableIfResolver;
    }
    return disableIfResolver !== undefined;
  }
}
